module.exports = __webpack_public_path__ + "media/fonts/ABC_Weise_Regular_201015-ec65e52bb8ddaf20495346726b17809a.ttf";